module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "btn control-button control-button-red",
    on: {
      "click": _vm.scrollup
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "btn control-button control-button-red",
    on: {
      "click": _vm.scrolldown
    }
  }, [_vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-inside-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/svg/up-arrow.svg",
      "alt": "",
      "width": "50px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-inside-wrap"
  }, [_c('img', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "src": "/static/svg/up-arrow.svg",
      "alt": "",
      "width": "50px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2cc7f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/UpDownPanel.vue
// module id = 1546
// module chunks = 1